import PillarsRecumbent from './PillarsRecumbent';

export default PillarsRecumbent;
